import React from 'react';
import { getFrontDoorPolicies } from '../utils/getFrontDoorPolicies';

interface MiniFrontDoorProps {
    children: React.ReactNode;
}

/**
 * MiniFrontDoor is a component that is used to regulate access to mini-owa
 * based on the policies defined in @see getFrontDoorPolicies.
 * @param props
 */
export default function MiniFrontDoor(props: MiniFrontDoorProps) {
    const activePolicy = getFrontDoorPolicies().find(rule => rule.condition());

    // If a policy is active, we want to restrict access to mini-owa.
    // Render the component associated with the policy
    if (activePolicy) {
        return <activePolicy.component />;
    }

    return <>{props.children}</>;
}
